import React from 'react';
import LeftNav from './../common/leftnav/leftnav';
import HeaderTop from './../common/headerTop/headerTop';
import FirewallRules from './firewallRules';
import CommonMessage from './../common/commonMessage';
import { FirewallService as firewallService } from './../../services/firewall.service';
import InstancesSelection from './instancesSelection';
import ReactTooltip from 'react-tooltip';
import $ from 'jquery';
import { AuditLog } from './../../services/auditlog.service';
import FirewallNewRules from './firewallNewRules';

class FirewallCreate extends React.Component {

    constructor(props) {
        super(props);
        // loadcss();
        let propsState = {}
        if (this.props.location.state !== undefined) {
            propsState = this.props.location.state;
        }
        this.state = {
            firewalldelete: false,
            firewallName: '',
            firewallForAudit : propsState.name,
            sgRules: '',
            id: propsState.id,
            regionUrl: propsState.regionUrl,
            message: '',
            isAction: false,
            ipv4:[],
            ipv6:[],
            msgType:'',
            regionName:propsState.regionName,
            editNameErr:'',
            firewallEditName:'',
            currentName:this.props.location.state.name,
            isDefaultFirewall:false,
            firewalls:[]
        }
        this.firewallDeletion = this.firewallDeletion.bind(this);
        this.goback = this.goback.bind(this);

    };
    componentDidMount() {
        if (this.props.location.state === undefined) {
            this.props.history.push('/firewall');
        } else {
            this.getFirewallDetails(false);
        }
        
    }

    

    getFirewallDetails(onlyUpdateCount){
        if(!onlyUpdateCount){
            //this.setState({ isAction: true});
        }
        let isDefaFirewallName = false
        firewallService.getFirewallDetailsByid(this.state.id,this.state.regionUrl).then(data => {
            if(data===false){
                this.setState({ errorMsg: 'API fetch failed.Try again!',msgType:'error' })
                return;
            }
            let firewallData = data.security_group;
            if(onlyUpdateCount){
                this.setState({sgRules:firewallData.security_group_rules});
                return
            }
            if(firewallData.name === 'default_firewall'){
                isDefaFirewallName = true;
            }
            this.setState({isDefaultFirewall: isDefaFirewallName, firewallName:firewallData.name,
                sgRules:firewallData.security_group_rules,
                ipv4:firewallData.security_group_rules.filter(elem=>elem.ethertype==='IPv4'),
                ipv6:firewallData.security_group_rules.filter(elem=>elem.ethertype==='IPv6')
            });
        });
    }
    

    
    firewallNameChange = (event) => {
        if(this.props.location.state.name === 'default_firewall'){
            this.setState({editNameErr:'System created firewall name cannot be changed'})
            document.getElementById('firewallname').focus();
            return
        }
        if(this.state.firewallEditName === undefined || this.state.firewallEditName === ''){
            this.setState({editNameErr:'Name should not be blank'})
            document.getElementById('firewallname').focus();
            return;
        }
        if (this.isFirewallNameExist(this.state.firewallEditName.trim())) {
            this.setState({ editNameErr: 'Firewall with the same name already exists' })
            return
        }
        if(this.state.firewallEditName.length > 20){
            this.setState({ editNameErr: 'Name should not be more than 20 characters' });
            document.getElementById('firewallname').focus();
            return false;
        }
        if( this.state.firewallEditName.trim()===this.state.firewallName.trim()){
            this.setState({ editNameErr: 'No changes found to edit' });
            document.getElementById('firewallname').focus();
            return false;
        }
        this.editNameClose()
        this.setState({ isAction: true });
        let reqBody = {
            name: this.state.firewallEditName.trim(),
            description: this.state.firewallEditName
        };
        let i18n = this.props.i18n
        firewallService.editFirewallById(this.state.id, JSON.stringify(reqBody), this.state.regionUrl).then(data => {
            if (data) {
                const editFirewall = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Firewall "+this.state.firewallForAudit+" updated to "+reqBody.name,
                    "operation": "Firewall name updated"
                } 
                AuditLog.storeAuditLogs(editFirewall, "instance").then((resp) => {
                    if (resp === false);
                })
                this.setState({message: i18n.t('fw_rename_success'),isAction: false,firewallName:this.state.firewallEditName.trim()});
            } else {
                this.setState({
                    message: i18n.t('fw_rename_failure'),
                    msgType: "error",
                    isAction: false
                });
            }
        });
    }

    goback = () => {
        this.props.history.push("/firewall")
    }

    firewallDeletion = () => {
        this.setState({
            firewalldelete: !this.state.firewalldelete
        })
    }

    formChangeHandler = (event) => {
        let name = event.target.name
        let val = event.target.value
        if(val.length > 20){
            return
        }
        this.setState({ firewallEditName: val ,editNameErr:''})
    }
    editNamePopup() {
        if(this.state.firewallName==='default_firewall'){
            this.setState({isDefaultFirewall:true})
            return
        }
        this.loadFirewallList()
        this.setState({ firewallEditName: this.state.firewallName,editNameErr:'' })
        $('.edit_firewall_popup').addClass('active');
        document.getElementById('firewallname').focus();
    }

    editNameClose(){
        $('.edit_firewall_popup').removeClass('active');
    }
    onFireKeydown = (e,type) => {
        if(e.keyCode === 13){
            this.firewallNameChange()
        }
    }

    isFirewallNameExist(name) {
        let firewallList = this.state.firewalls;
        if (firewallList.length > 0) {
            let regName = this.state.regionName
            let regnList = firewallList.filter(item => item.region_name === regName)
            if (regnList.length > 0) {
                let ob = regnList.find(elem => elem.name === name)
                if (ob !== undefined) {
                    return true
                }
            }
        }
        return false
    }

    loadFirewallList() {
        firewallService.getFirewallList().then(data => {
            if (!Array.isArray(data) || (data && data.message)) {
                this.setState({ isAction: false });
                return;
            }
            this.setState({ firewalls: data});
        });
    }
    

    render() {
        if (this.props.location.state === undefined) {
            return null;
        }
        let deleteclassactive = "main_popup delete_firewall_popup"
        if (this.state.firewalldelete) {
            deleteclassactive = "main_popup delete_firewall_popup active"
        }
        return (
            <div className="main_nav_module firewall_main_module firewall_create_edit oly_create_firewall">
                <main>
                    <div className="full_page_loader" style={{ display: this.state.isAction ? 'block' : 'none' }}>
                        <div className="loader_icon"></div>
                    </div>
                    <LeftNav isActive={'firewall'}></LeftNav>

                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={false}></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="computer_no"> <span className="bck_icon" onClick={this.goback} data-tip data-for = "back"><span className="svg_wrap">&#x2794;</span></span><ReactTooltip multiline={true} id="back" place= "right" effect="solid"> Back to firewall list page </ReactTooltip>
                                             <span className="firewall_icon"><span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 25 25" enableBackground="new 0 0 25 25" xmlSpace="preserve">
                                                <g>
                                                    <path fill="#5AA6D8" d="M23.7,12.9c-0.1,0.7-0.4,2.7-1.9,2.8c1.2-4.3-2.9-7.5-3.9-7.6c0.5,2.6-0.6,3.2-2.4,5.7   c-3.8,5.7,1.5,9.3,1.5,9.3c0.5,0.4,1.3,0.2,3.4,0.3C27.4,21.4,23.8,12.1,23.7,12.9z"></path>
                                                    <path fill="#5AA6D8" d="M12.6,21.4h-0.3v-4.7h0.3v-1.9h-5V10c0-0.6-0.4-0.9-0.9-0.9S5.8,9.5,5.8,10v4.7H1.9V10h4.7h7.6   c0-0.6,0-1.3,0-1.9h-1.9V3.4H19c1,0,1.9,0.9,1.9,1.9v1.9v0.9c0,0.6,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V7.2V4.4c0-1.6-1.2-2.8-2.8-2.8   H2.8C1.2,1.6,0,2.9,0,4.4v16.1c0,1.6,1.2,2.8,2.8,2.8h8.5h1.2v-2H12.6z M1.9,5.3c0-1,0.9-1.9,1.9-1.9h6.6v4.7H1.9V5.3z M10.4,21.4   H3.8c-1,0-1.9-0.9-1.9-1.9v-2.8h8.5V21.4z"></path>
                                                </g>
        </svg></span> </span> <span className="text bold_600">{this.state.firewallName} ({this.state.regionName}) </span><span className="text bold_600">&nbsp;-&nbsp;</span><span className="title_info">{this.state.sgRules.length} {this.state.sgRules.length>1?'Rules':'Rule'}</span>
                                        </div>
                                    </div>
                                    <div className="bn_right">
                                        <div className="setting_header_options">
                                            <ul>
                                                <li className="firewall_edit" data-tip data-for="isDefaultFirewall" onClick={() => this.editNamePopup()}><span  className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                </svg></span>
                                                {this.state.isDefaultFirewall?<ReactTooltip id="isDefaultFirewall" effect = "solid" place="left" >Default firewall cannot be renamed</ReactTooltip>:null}
                                                 Rename</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </header>
                        <section className="main_section">
                            <div className="main_body_container">
                                <div className="mainBody_colWrap">
                                    <div className="firewall_create_edit_wrap clearfix">
                                        <div className="rules_container inbound_rule clearfix" style={{padding: '0px 0 45px'}}>
                                            <h2>IPv4 Rules</h2>
                                            {/* <p className="title_info">Create inbound firewall rules for ingress traffic</p> */}
                                            <FirewallNewRules rulesListApi={this.state.ipv4} type="IPv4" firewallName = {this.state.firewallName}
                                                regionUrl={this.state.regionUrl} id={this.state.id} 
                                                handler={(msg,mesgType)=>this.setState({message:msg,msgType:mesgType})}
                                                bgShadowHandler={(isAction)=>this.setState({isAction:isAction})} 
                                                updateCountHandler={()=>this.getFirewallDetails(true)} i18n={this.props.i18n}/>
                                        </div>
                                        <div className="rules_container outbound_rule clearfix" style={{padding: '0px 0 45px'}}>
                                            <h2>IPv6 Rules</h2>
                                            {/* <p className="title_info">Create outbound firewall rules for egress traffic</p> */}
                                            <FirewallNewRules rulesListApi={this.state.ipv6} type="IPv6" firewallName = {this.state.firewallName}
                                            regionUrl={this.state.regionUrl} id={this.state.id} 
                                            handler={(msg,mesgType)=>this.setState({message:msg,msgType:mesgType})} 
                                            bgShadowHandler={(isAction)=>this.setState({isAction:isAction})} 
                                            updateCountHandler={()=>this.getFirewallDetails(true)} i18n={this.props.i18n}/>
                                        </div>
                                        <InstancesSelection name={this.state.firewallName} handler={(msg,mesgType)=>this.setState({message:msg,msgType:mesgType})} 
                                        regionName={this.state.regionName}  bgShadowHandler={(isAction)=>this.setState({isAction:isAction})} i18n={this.props.i18n}/>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>

                   <div className="main_popup edit_firewall_popup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={() => this.editNameClose()}></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Rename <b>{this.state.firewallName}</b></div>
                                </div>
                                <div className="popup_body">
                                    <div className="common_txtBox_row">
                                        <label>Name</label>
                                        <input id="firewallname" type="text" placeholder = "Provide a new name" autoComplete="off" name="name" value={this.state.firewallEditName} className="txtBox edit_name_inp" onChange={(e) => this.formChangeHandler(e)} tabIndex="1" onKeyDown={(e)=>this.onFireKeydown(e)} />
                                        <span className="comm_error_msg"> {this.state.editNameErr} </span>
                                    </div>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className="btn blue" onClick={this.firewallNameChange} tabIndex="2">Save Changes</button>
                                        <button className="btn btn_cancel" onClick={() => this.editNameClose()} tabIndex="3">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CommonMessage message={this.state.message} msgType={this.state.msgType} handler={() => this.setState({ message: '' })} />
            </div>
        )
    }
}
function loadcss() {
    const link = document.createElement("link")
    // link.href = "https://www.idrivecompute.com/webapp/css/firewall.css"
    link.href = "https://www.idrivecompute.com/webapp/css/style.css"
    link.rel = "stylesheet"
    link.type = "text/css"
    document.head.appendChild(link)
}

export default FirewallCreate;